import { Nullable } from '../../types/common'
import { parseHTML } from '../../utils/dom'
import { delay } from '../../utils/utils'
import RecentlyViewed from '../recently-viewed/recently-viewed'
import Sidebar from '../sidebar/sidebar'

const { Shopify }: any = window

class QuickViewComponent extends Sidebar {
  cache: object
  isRenderedOnPage: Nullable<HTMLElement>
  content: Nullable<HTMLElement>

  constructor() {
    super()

    this.cache = {}
  }

  requestProductFromUrl(url: string, id: string): void {
    if (!this.cache[url]) {
      this.isRenderedOnPage = document.querySelector(
        `.shopify-section [data-quick-view-product-id="${id}"]`,
      )

      if (
        this.isRenderedOnPage &&
        this.isRenderedOnPage.dataset.quickViewProductUrl === url
      ) {
        this.cache[url] = delay(0).then(() => this.isRenderedOnPage)
      } else {
        this.cache[url] = fetch(url)
          .then(response => response.text())
          .then(responseText => parseHTML(responseText))
      }
    }
  }

  handleContentScroll = (): void => {
    const isScrolled = this.content ? this.content.scrollTop > 0 : false

    this.toggleAttribute('header-shadow-visible', isScrolled)
  }

  open(): any {
    //
  }

  openAndRenderProductByUrl = (url: string): void => {
    if (this.cache[url]) {
      this.cache[url].then(html => {
        if (this.isRenderedOnPage) {
          this.isRenderedOnPage.replaceChildren()
        }

        if (this.isOpen) {
          this.hide().then(() => {
            this.setProductFromHTML(html)

            super.open()
          })
        } else {
          this.setProductFromHTML(html)

          super.open()
        }

        Shopify?.PaymentButton?.init()
      })
    }
  }

  setProductFromHTML(html: Document): void {
    if (this.dataset.targetId) {
      const target = html.getElementById(this.dataset.targetId)

      if (target) {
        RecentlyViewed.updateProductsInLocalStorage(
          target.dataset.productString,
          target.dataset.productHandle,
        )

        const targetClass = target.getAttribute('class') || ''
        const clonedTarget = target.cloneNode(true)

        this.element.setAttribute('class', targetClass)
        this.element.replaceChildren(...clonedTarget.childNodes)
        this.content = this.element.querySelector('[data-quick-view-content]')

        if (this.content) {
          this.content.addEventListener('scroll', this.handleContentScroll)
        }
      }
    }
  }

  resetProduct(): void {
    if (this.content) {
      this.content.removeEventListener('scroll', this.handleContentScroll)

      if (this.isRenderedOnPage) {
        const clonedContent = this.content.cloneNode(true)

        this.isRenderedOnPage.replaceChildren(...clonedContent.childNodes)
      }

      this.content = null
    }

    this.element.replaceChildren()
  }
}

export default QuickViewComponent
